<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link :to="{name: 'bonusCards.create'}" class="btn btn-success" v-if="$store.state.role != 'finance'">ثبت سفارش بن کارت</router-link>
            <router-link :to="{name: 'bonusCards.charge'}" class="btn btn-info mr-2" v-if="$store.state.role != 'finance'">شارژ کارت</router-link>
            <router-link :to="{name: 'bonusCards.requests'}" class="btn btn-secondary mr-2">لیست درخواست ها</router-link>
            <router-link :to="{name: 'bonusCards.cardPin'}" class="btn btn-primary mr-2" v-if="$store.state.role != 'finance'">صدور رمز کارت</router-link>
            <router-link :to="{name: 'bonusCards.blockUnblock'}" class="btn btn-dark mr-2" v-if="$store.state.role != 'finance'">درخواست مسدودی / رفع مسدودی کارت</router-link>
            <router-link v-if="!$store.state.userData.isOrganization && !$store.state.userData.isPishkhan" :to="{name: 'bonusCards.contract'}" class="btn btn-warning mr-2">ایجاد قرارداد</router-link>
            <button class="btn btn-warning mr-2" data-toggle="collapse" data-target="#advanced-search">جستجو پیشرفته</button>
            <div id="advanced-search" class="collapse">
                <div class="row mt-3">
                    <div class="col-md-2">
                        <label>از تاریخ</label>
                        <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" v-model="fromDate" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                    <div class="col-md-2">
                        <label>تا تاریخ</label>
                        <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" v-model="toDate" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>شماره کارت</label>
                            <input type="tel" class="form-control text-center" v-model="pan" v-mask="'####-####-####-####'">
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="form-group">
                            <label>کد ملی</label>
                            <input type="tel" class="form-control" v-model="nationalCode" v-mask="'##########'">
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>کد پیگیری</label>
                            <input type="tel" class="form-control" v-model="trackingCode" v-mask="'##########'">
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="form-group">
                            <label>نوع</label>
                            <select class="form-control" v-model="type">
                                <option value="0">همه</option>
                                <option value="81">کارت نقدی</option>
                                <option value="101">بن کارت</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-primary btn-block" style="margin-top:29px;" @click="getData()">
                            <i class="si si-magnifier"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
            <hr>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :postedData="postedData" :count="count" :url="'Organizations/Bonus/Orders/Search/Org'" :operations="['bonusCards',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'orderId'
                },
                {
                    title: 'دارنده کارت',
                    field: 'customerName'
                },
                {
                    title: 'وضعیت سفارش',
                    field: 'statusTitle'
                },
                {
                    title: 'نوع سفارش',
                    field: 'orderType'
                },
                {
                    title: 'مبلغ',
                    field: 'amount'
                },
                {
                    title: 'تاریخ',
                    field: 'createdAt'
                },
                {
                    title: 'ساعت',
                    field: 'createdAtTime'
                }
            ],
            rows: [],
            showLoading: true,
            count: 0,
            pan: null,
            nationalCode: null,
            trackingCode: null,
            fromDate: null,
            toDate: null,
            statuses: [],
            postedData: {},
            type: '0',
            dataTableKey: 0
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            this.postedData = {
                fromDate: this.fromDate,
                toDate: this.toDate,
                trackingCode: this.trackingCode,
                nationalCode: this.nationalCode,
                cardNumber: this.pan,
                statuses: this.statuses,
                orderType: this.type && this.type != 0 ? [parseInt(this.type)] : [],
            }
            this.$api.post('Organizations/Bonus/Orders/Search/Org',{...this.postedData,page: 1,perPage: 10,}).then(({data}) => {
                if(data.status){
                    this.rows = [];
                    data.result.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال'
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['bonusCards',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>